
import {
    FETCHING_CUSTOM_FIELDS, FETCHING_CUSTOM_FIELDS_SUCCEEDED, FETCHING_CUSTOM_FIELDS_FAILED,
    DELETING_CUSTOM_FIELD, DELETING_CUSTOM_FIELD_SUCCEEDED, DELETING_CUSTOM_FIELD_FAILED,
    FETCHING_CUSTOM_FIELD, FETCHING_CUSTOM_FIELD_SUCCEEDED, FETCHING_CUSTOM_FIELD_FAILED,
    CREATE_CUSTOM_FIELD, CREATING_CUSTOM_FIELD_SUCCEEDED, CREATING_CUSTOM_FIELD_FAILED,
    UPDATE_CUSTOM_FIELD, UPDATING_CUSTOM_FIELD_SUCCEEDED, UPDATING_CUSTOM_FIELD_FAILED,
    REORDER_CUSTOM_FIELDS, REORDERING_CUSTOM_FIELDS_SUCCEEDED, REORDERING_CUSTOM_FIELDS_FAILED,
    INVALIDATE_CUSTOM_FIELDS
} from 'constants/actionTypes';
  
import { call, put, select, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import _ from 'lodash';
  
const apiUrl = `${process.env.REACT_APP_CLEVERSTORY_API_URL}/api/2.0`;
const CUSTOM_FIELD_URL = `${apiUrl}/custom_fields`;


/* Fetch Custom Fields For Storyboard 
*/
export const fetchCustomFields = createAction(FETCHING_CUSTOM_FIELDS, (storyboard) => {
 return {
    storyboard: storyboard
 }
});

const fetchCustomFieldsSucceeded = createAction(FETCHING_CUSTOM_FIELDS_SUCCEEDED, (response) => {
 return response;
})

const fetchCustomFieldsFailed = createAction(FETCHING_CUSTOM_FIELDS_FAILED, (error) => {
 return error;
})

function* fetchCustomFieldsSaga(action) {
 const { storyboard } = action.payload;

 const params = {
    storyboard: storyboard
 };

 let url = buildUrl(CUSTOM_FIELD_URL, {
   queryParams: params
 });

 const fetchCustomFieldsAPI = () => {
   return axios.get(url).then(response => response.data);
 }

 try {
   const response = yield call(fetchCustomFieldsAPI);
   if (response) {
     yield put(fetchCustomFieldsSucceeded(response));
   }
 } catch (error) {
   yield put(fetchCustomFieldsFailed(error));
 }
}

/* Delete a Custom Field
*/

export const deleteCustomField = createAction(DELETING_CUSTOM_FIELD, (storyboard, id) => {
    return {
        storyboard: storyboard,
        id: id
    }
});

const deleteCustomFieldSucceeded = createAction(DELETING_CUSTOM_FIELD_SUCCEEDED, (response) => {
    return response;
})

const deleteCustomFieldFailed = createAction(DELETING_CUSTOM_FIELD_FAILED, (error) => {
    return error;
})

function* deleteCustomFieldSaga(action) {
    const { storyboard, id } = action.payload;

    const params = {
        storyboard: storyboard
    };

    let url = buildUrl(CUSTOM_FIELD_URL, {
        path: `/${id}`,
        queryParams: params
    });

    const deleteCustomFieldAPI = () => {
        return axios.delete(url).then(response => response.data);
    }

    try {
        const response = yield call(deleteCustomFieldAPI);
        if (response) {
        yield put(deleteCustomFieldSucceeded(response));
        }
    } catch (error) {
        yield put(deleteCustomFieldFailed(error));
    }
}

/* Fetch a Custom Field */

export const fetchingCustomField = createAction(FETCHING_CUSTOM_FIELD, (storyboard, id) => {
    return {
        storyboard: storyboard,
        id: id
    }
});

const fetchingCustomFieldSucceeded = createAction(FETCHING_CUSTOM_FIELD_SUCCEEDED, (response) => {
    return response;
})

const fetchingCustomFieldFailed = createAction(FETCHING_CUSTOM_FIELD_FAILED, (error) => {
    return error;
})

function* fetchCustomFieldSaga(action) {
const { storyboard, id } = action.payload;

const params = {
    storyboard: storyboard
};

let url = buildUrl(CUSTOM_FIELD_URL, {
    path: `/${id}`,
    queryParams: params
  });

const fetchCustomFieldAPI = () => {
    return axios.get(url).then(response => response.data);
}

try {
    const response = yield call(fetchCustomFieldAPI);
    if (response) {
    yield put(fetchingCustomFieldSucceeded(response));
    }
} catch (error) {
    yield put(fetchingCustomFieldFailed(error));
}
}

/*
* Create Custom Field
*/
export const createCustomField = createAction(CREATE_CUSTOM_FIELD, (storyboard, request) => {
    return {
        storyboard: storyboard,
        request: request
    }
});
  
const createCustomFieldSucceeded = createAction(CREATING_CUSTOM_FIELD_SUCCEEDED, (request, response) => {
    return {
        request: request,
        response: response
    }
});

const createCustomFieldFailed = createAction(CREATING_CUSTOM_FIELD_FAILED, (request, error) => {
    return {
        request: request,
        error: error
    }
});
  
function* createCustomFieldSaga(action) {
    const { storyboard, request } = action.payload;

    const params = {
        storyboard: storyboard
    };
  
    let url = buildUrl(CUSTOM_FIELD_URL, {
      queryParams: params
    });
  
    const createCustomFieldAPI = () => {
      return axios.post(url, request).then(response => response.data);
    }
  
    try {
      const response = yield call(createCustomFieldAPI);
      if (response) {
        yield put(createCustomFieldSucceeded(request, response));
      }
    } catch (error) {
      yield put(createCustomFieldFailed(request, error));
    }
}

/*
* Update Custom Field
*/
export const updateCustomField = createAction(UPDATE_CUSTOM_FIELD, (storyboard, id, request) => {
    return {
      storyboard: storyboard,
      id: id,
      request: request
    }
  });
  
  const updateCustomFieldSucceeded = createAction(UPDATING_CUSTOM_FIELD_SUCCEEDED, (request, response) => {
    return {
      request: request,
      response: response
    }
  });
  
  const updateCustomFieldFailed = createAction(UPDATING_CUSTOM_FIELD_FAILED, (request, error) => {
    return {
      request: request,
      error: error
    }
  });
  
  function* updateCustomFieldSaga(action) {
    const { id, storyboard, request } = action.payload;

    const params = {
        storyboard: storyboard
    };
  
    let url = buildUrl(CUSTOM_FIELD_URL, {
      path: `/${id}`,
      queryParams: params
    });
  
    const updateCustomFieldAPI = () => {
      return axios.put(url, request).then(response => response.data);
    }
  
    try {
      const response = yield call(updateCustomFieldAPI);
      if (response) {
        yield put(updateCustomFieldSucceeded(request, response));
      }
    } catch (error) {
      yield put(updateCustomFieldFailed(request, error));
    }
  }

/**
 * Reorder Custom Fields
 */

export const reorderCustomFields = createAction(REORDER_CUSTOM_FIELDS, (storyboard, fields) => {
    return {
        storyboard: storyboard,
        request: fields
    }
})
  
const reorderingCustomFieldsSucceeded = createAction(REORDERING_CUSTOM_FIELDS_SUCCEEDED, (request, response) => {
    return {
        request: request,
        response: response
    }
});

const reorderingCustomFieldsFailed = createAction(REORDERING_CUSTOM_FIELDS_FAILED, (request, error) => {
  return {
    request: request,
    error: error
  }
});

function* reorderCustomFieldsSaga(action) {
  const {storyboard, request } = action.payload;

  const params = {
      storyboard: storyboard
  };

  let url = buildUrl(CUSTOM_FIELD_URL, {
      path: `/order`,
    queryParams: params
  });

  const reorderCustomFieldAPI = () => {
    return axios.put(url, request).then(response => response.data);
  }

  try {
    const response = yield call(reorderCustomFieldAPI);
    if (response) {
      yield put(reorderingCustomFieldsSucceeded(request, response));
    }
  } catch (error) {
    yield put(reorderingCustomFieldsFailed(request, error));
  }
}

export const invalidateCustomFields = createAction(INVALIDATE_CUSTOM_FIELDS);

export default function* fieldsSaga() {
    yield takeEvery(FETCHING_CUSTOM_FIELDS, fetchCustomFieldsSaga)
    yield takeEvery(DELETING_CUSTOM_FIELD, deleteCustomFieldSaga)
    yield takeEvery(FETCHING_CUSTOM_FIELD, fetchCustomFieldSaga)
    yield takeEvery(CREATE_CUSTOM_FIELD, createCustomFieldSaga)
    yield takeEvery(UPDATE_CUSTOM_FIELD, updateCustomFieldSaga)
    yield takeEvery(REORDER_CUSTOM_FIELDS, reorderCustomFieldsSaga)
}